const email = 'leilakrejci@gmx.de';

export {email};